import http from "./http_common";

class ProcedureService {
  queryString(payload) {
    const QueryString = Object.keys(payload)
      .map((key) => key && payload[key] && key + "=" + payload[key])
      .join("&");
    return QueryString;
  }
  ProcedureRequest(payload) {
    return http.post("/procedureRequest/save", payload);
  }
  HosiptalList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/Clinic_Master/list/filter/withAccount?${queryString}`);
  }
}

export default new ProcedureService();
